import React, {Component} from "react"
import PropTypes from "prop-types"
import {Grid} from "react-bootstrap"

import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"
import {getBannerImage, getThumbnailImage} from "@irati/utils/images/getImageSize/getImageSize"
import {FormattedMessage} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import BrandAvatar from "@irati/ui/src/BrandAvatar"
import Button from "@irati/ui/src/Button"

import Container from "./styled/Container"
import StyledBanner from "./styled/Banner"
import StyledCol from "./styled/Col"
import H1WithShadow from "./styled/H1"

class HomePageBanner extends Component {
  static propTypes = {
    deal: PropTypes.object
  }
  static defaultProps = {
    deal: null
  }

  constructor(props) {
    super(props)
    this.state = {
      counter: 0
    }
  }

  render() {
    const {deal} = this.props

    if (!deal) return null

    const dealUrl = `/info/${deal.urlSlug}`
    const idNamespace = id("homepage-banner", this.props)
    return (
      <StyledBanner id={idNamespace} src={getBannerImage(deal.bannerImage)}>
        <Grid>
          <RouterLink
            plain
            id={id("link", idNamespace)}
            to={dealUrl}
            onClick={() => tracking.clickHomepagePerk(deal, {sectionHeader: "hero", position: 1})}
            styled={false}>
            <Container>
              <StyledCol>
                <BrandAvatar id={id("image-logo", idNamespace)} src={getThumbnailImage(deal.thumbnailImage)} alt="brand logo" margin={0} />
              </StyledCol>
              <div>
                <H1WithShadow
                  id={id("title", idNamespace)}
                  marginBottom={2}
                  overflowWrap="break-word"
                  maxWidth="607px">
                  {deal.header}
                </H1WithShadow>
                <Button id={id("label", idNamespace)} primary>
                  <FormattedMessage id="perks.components.homePageBanner.getThisPerk" />
                </Button>
              </div>
            </Container>
          </RouterLink>
        </Grid>
      </StyledBanner>
    )
  }
}

export default HomePageBanner
